import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter,
  Output, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';



import { columns } from './columns';

import { BrandService } from 'shared/brand/brand.service';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { ExportScheduleManagerSearchComponent } from '../export-schedule-manager-search/export-schedule-manager-search.component';
import { ExportScheduleManagerSearchService } from '../export-schedule-manager-search/export-schedule-manager-search.service';
import { LoaderComponent } from 'shared/loader/loader.component';
import {finalize, takeWhile} from 'rxjs/operators';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'export-schedule-manager-modal',
  templateUrl: 'export-schedule-manager-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportScheduleManagerModalComponent extends BaseModalComponent {

  @ViewChild(ExportScheduleManagerSearchComponent, {static: false})
  scheduleSearch: ExportScheduleManagerSearchComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  sortingColumns: Array<any> = columns;

  constructor(
    private ref: ChangeDetectorRef,
    private searchService: ExportScheduleManagerSearchService,
    private brandService: BrandService,
  ) {
    super();
  }

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get selectedItems(): Array<any> {
    return _.get(this, 'scheduleSearch.selectedRows', []);
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onModalHide() {
    this.hide();
  }

  onRemoveClick() {
    if (this.loader) {
      this.loader.show();
    }
    const ids = _.map(this.selectedItems, (item: any) => {
      return _.get(item, '_id');
    });

    this.searchService.deleteItems(
      this.brandService.getBrand(),
      ids,
    )
    .pipe(finalize(() => this.loader && this.loader.hide()), takeWhile(() => this.isModalShown && this.isActive))
    .subscribe(() => {
      if (this.scheduleSearch) {
        this.scheduleSearch.reset();
        this.scheduleSearch.updateSearch();
      }
    });
  }

  /*******************************************
  * COMPONENT METHODS
  *******************************************/

  show() {
    super.show();
  }

  hide() {
    this.resetData();
    super.hide();
    this.ref.markForCheck();
  }

  resetData(): void {
    if (this.scheduleSearch) {
      this.scheduleSearch.reset();
    }
  }
}
